<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="500px"
      scrollable>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="error"
          icon
          v-bind="attrs"
          v-on="on">
          <v-icon>mdi-delete-outline</v-icon>
        </v-btn>
      </template>
      <alert-remove-card
        @confirm="submit()"
        @close="closeDialog()" />
    </v-dialog>
  </div>
</template>

<script>
import AlertRemoveCard from '@/components/Card/AlertRemoveCard.vue'
import { DELETE_BANK_ACCOUNT } from '@/resources/graphql'

export default {
  name: 'PaymentRemove',
  components: {
    AlertRemoveCard
  },
  props: {
    bankId: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    closeDialog () {
      this.dialog = false
    },
    async submit () {
      await this.$apollo.mutate({
        mutation: DELETE_BANK_ACCOUNT,
        variables: {
          input: {
            id: this.bankId
          }
        }
      })
      this.$emit('submit')
      this.closeDialog()
    }
  }
}
</script>
